import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchWrapper } from './../_helpers';


// create slice

const name = 'subCategory';
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers= (builder) => {
    createExtraReducers(builder);
}
const slice = createSlice({ name, initialState, extraReducers });

// exports

export const subCategoryActions = { ...slice.actions, ...extraActions };
export const subCategoryReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        subCategory:{},
        subCategoryList: [],
         isLoading:false,
        error: null,
        subCategoryResponse: [],
        deleteSubCategoryResponse:[]
    }
}

function createExtraActions() {
     const baseUrl = `${process.env.REACT_APP_API_URL}/SubCategory`;
    return {
        getSubCategoryAll: getSubCategoryAll(),
        getSubCategoryById:getSubCategoryById(),
        saveSubCategory: saveSubCategory(),
        deleteSubCategory:deleteSubCategory(),
    };

    function getSubCategoryAll() {
        return createAsyncThunk(
            `${name}/getSubCategoryAll`,
            async () => await fetchWrapper.get(`${baseUrl}/GetSubCategoryDetails`)
             // async () => await UserService.getAllUserList()
        );
    }
     function getSubCategoryById() {
        return createAsyncThunk(
            `${name}/getSubCategoryById`,
             async (detail) => await fetchWrapper.get(`${baseUrl}/GetSubCategoryDetails?SubCategoryID=`+detail.SubCategoryID)
            // async (Id) => await UserService.getUserById(Id)
        );
    }

    function saveSubCategory() {
        return createAsyncThunk(
            `${name}/saveSubCategory`,
             async (addFormData) => await fetchWrapper.post(`${baseUrl}/InsertUpdateSubCategory`, addFormData )
           // async (addFormData) => await UserService.InsertUpdateUser(addFormData)
        );
    }

    function deleteSubCategory()
    {
        return createAsyncThunk(
            `${name}/deleteSubCategory`,
             async (detail) => await fetchWrapper.post(`${baseUrl}/DeleteSubCategory?SubCategoryID=${detail.SubCategoryID}&DeletedBy=${detail.DeletedBy}`)
          
        );
    }
}


function createExtraReducers(builder) {
    builder
        .addCase(extraActions.getSubCategoryAll.pending, (state) => { //getSubCategoryAll
            state.isLoading = false;
            state.error = "";
        })
        .addCase(extraActions.getSubCategoryAll.fulfilled, (state, action) => {
            state.isLoading = true;
            state.subCategoryList = action.payload || [];
            state.subCategoryResponse = [];
            state.deleteSubCategoryResponse = [];
        })
        .addCase(extraActions.getSubCategoryAll.rejected, (state, action) => {
            state.isLoading = true;
            state.error = { error: action.error };
        })
        .addCase(extraActions.getSubCategoryById.pending, (state) => { //getSubCategoryById
            state.subCategory = { loading: true };
        })
        .addCase(extraActions.getSubCategoryById.fulfilled, (state, action) => {
            state.subCategory = action.payload ? action.payload[0] : null;
            state.subCategoryResponse = [];
            state.deleteSubCategoryResponse = [];
        })
        .addCase(extraActions.getSubCategoryById.rejected, (state, action) => {
            state.subCategory = { error: action.error };
        })
        .addCase(extraActions.saveSubCategory.pending, (state) => {  //saveSubCategory
            state.subCategoryResponse = { loading: true };
        })
        .addCase(extraActions.saveSubCategory.fulfilled, (state, action) => {
            state.subCategoryResponse = action.payload;
            state.deleteSubCategoryResponse = [];
        })
        .addCase(extraActions.saveSubCategory.rejected, (state, action) => {
            state.subCategoryResponse = { error: action.error };
        })
        .addCase(extraActions.deleteSubCategory.pending, (state) => { //deleteSubCategory
            state.subCategoryResponse = { loading: true };
        })
        .addCase(extraActions.deleteSubCategory.fulfilled, (state, action) => {
            state.deleteSubCategoryResponse = action.payload;
            state.subCategoryResponse = [];
        })
        .addCase(extraActions.deleteSubCategory.rejected, (state, action) => {
            state.deleteSubCategoryResponse = { error: action.error };
        });
}
